import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslate } from "../../hooks/LanguageProvider";
import { toast } from "react-toastify";
import { useClipboard } from "../../utilities/functions";
import SelectGroup from "./SelectGroup";
import '../../../src/App.css'
import ProgramTable from "./ProgramTable";
import ModalDeleteProgram from "./DeleteProgram";
import ModalShowProgram from "./ShowProgram";


//const id_user = localStorage.getItem("userid");

// Définir les types pour les props
interface ModalNewDeadlineProps {
    show: boolean;
    onHide: () => void;
    id_site: number | null;
    onSuccess?: () => void;
    onEnterEditMode?: (programId: number, programData: any) => void;
    editProgramId?: number | null;
    //editProgramData?: ProgramInterface | null;
    editProgramData?: any;
}
interface ProgramFormData {
    program_date: string;
    id_client: string;
    id_departure: string;
    destination_ids: string[];  
    type: string;
    id_conducteur: string;
    id_vehicle: string;
    observation: string;
    status: string;
}
const typeOptions = ["BBA","C","M","CB","PB","MALAX","7T","10T","5T","2T5","3T5","1T5","1,5T","CLINIQUE","CC","P"];
const statusOptions = ["planned","in_progress","completed","canceled"];

const backendUrl = process.env.REACT_APP_BACKEND_URL;
//const geopuserID = localStorage.getItem("GeopUserID");

const ModalNewDeadline: React.FC<ModalNewDeadlineProps> = ({
  show,
  onHide,
  id_site,
  onSuccess,
  editProgramData,
}) => {

    



  const [list_Program, setListProgram] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  


// For column visibility
const [selectedColumns, setSelectedColumns] = useState({
    id_program: true,
    program_date: true,
    departure: true,
    destination: true,
    type: true,
    observation: true,
    status: true,
    nom_conducteur: true,
    immatriculation_vehicule: true,
    client_name: true,
  });
  const handleSelectAllDrivers = (checked: boolean) => {
    setSelectAll(checked);
    if (checked) {
      setSelectedDeadlines(list_Program.map(p => p.id_program?.toString()));
    } else {
      setSelectedDeadlines([]);
    }
  };
  // For checkboxes
  const [selectedDeadlines, setSelectedDeadlines] = useState<string[]>([]);
const [selectAll, setSelectAll] = useState(false);

// Sorting state
const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
const [column, setColumn] = useState("id_site");

// Pagination and search
const [limit, setLimit] = useState(10);
const [currentPage, setCurrentPage] = useState(1);

const { translate } = useTranslate();
const { copyToClipboard, copiedId } = useClipboard(translate("Matriculation Copied"));


//this change added due to switch from admin to non admin user, no such thing needed when logging in directly as non admin (client), could be removed => program page refresh needed when admin to non admin switch
const [id_user, setIdUser] = useState(localStorage.getItem("userid"));
useEffect(() => {
  if (id_user === "1") {
    const handleStorageChange = () => {
      const newUserId = localStorage.getItem("userid");
      if (newUserId !== id_user) {
        setIdUser(newUserId);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }
}, [id_user]);


const [typeSearch, setTypeSearch] = useState(
  id_user === "1" ? "ID Program" : "Program Date" // Default to "Program Date" for non-admins
)
const [search, setSearch] = useState("");
const [type, setType] = useState(id_user === "1" ? 0 : 1);
const [total, setTotal] = useState(0);
const [pageCount, setPageCount] = useState(0);

useEffect(() => {
  console.log("User changed to:", id_user);
  
  // Reset search type based on user role
  if (id_user === "1") {
    console.log("Setting admin defaults: type=0, typeSearch=ID Program");
    setTypeSearch(translate("ID Program"));
    setType(0);
  } else {
    console.log("Setting user defaults: type=1, typeSearch=Program Date"); 
    setTypeSearch(translate("Program Date"));
    setType(1);
  }
  
  // Clear search ,reset to first page
  setSearch("");
  setCurrentPage(1);
  
}, [id_user, translate]); 


// State for program deletion modal
const [showDeleteProgramModal, setShowDeleteProgramModal] = useState(false);
const [selectedProgramId, setSelectedProgramId] = useState<number | null>(null);
// Handler to open program deletion modal
const handleDeleteProgramModal = (id: number) => {
  setSelectedProgramId(id);
  setShowDeleteProgramModal(true);
};

//state for program details
const [showShowProgramModal, setshowShowProgramModal] = useState(false);
//Handler for program details
const handleshowShowProgramModal = (id: number) => {
    setSelectedProgramId(id);
    setshowShowProgramModal(true);
  };
const handleCloseShowProgramModal = () => setshowShowProgramModal(false);

//Edit state
const [isEditMode, setIsEditMode] = useState(false);
const [editingProgramId, setEditingProgramId] = useState<number | null>(null);
/*const [editingProgramData, setEditingProgramData] = useState<ProgramInterface | null>(null);

const handleEditProgram = (program: any) => {
  setEditingProgram(program); // Use the state approach
  setSelectedSiteId(program.id_site || null);
  handleShowNewDeadlineModal();
};*/


//Mode switching functions
const enterEditMode = (programId: number, programData: any) => {
  //console.log("enterEditMode programData:", programData);
  //console.log("=== EDIT MODE DEBUG ===");
  //console.log("Program data received:", programData);
  //console.log("Available destinations:", destinations);
  setIsEditMode(true);
  setEditingProgramId(programId);
  const departureId = destinations.find(dest => dest.name === programData.departure)?.id_destination.toString() || "";

  const destinationIds: string[] = [];
  if (programData.destination) {
    const destNames = programData.destination.split(', '); // Split the comma-separated string
    destNames.forEach((name: string) => {
      const dest = destinations.find(d => d.name === name.trim());
      if (dest) {
        destinationIds.push(dest.id_destination.toString());
      }
    });
  }


  setFormData(prev => ({
    ...prev,
    program_date: programData.program_date ? (() => {
      const d = new Date(programData.program_date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    })(): "",
    id_client: programData.id_client !== undefined && programData.id_client !== null ? String(programData.id_client) : "",
    id_departure: departureId,
    destination_ids: destinationIds ,
    type: programData.type || "",
    observation: programData.observation || "",
    status: programData.status || "planned",
    id_conducteur: programData.id_conducteur !== undefined && programData.id_conducteur !== null ? String(programData.id_conducteur) : "",
    id_vehicle: programData.id_vehicle !== undefined && programData.id_vehicle !== null ? String(programData.id_vehicle) : "",
  }));
};

const handleModalHide = () => {
  exitEditMode(); // Reset to create mode
  setSearchTerm('');
  onHide?.();     // Close modal
};


const exitEditMode = () => {
  setIsEditMode(false);
  setEditingProgramId(null);
  setFormData(prev => ({
    ...prev,
    program_date: "",
    id_client:"",
    id_departure: "",
    destination_ids: [],
    type: "",
    id_conducteur:"",
    id_vehicle:"",
    observation: "",
    status: "planned",
  }));
  setSearchTerm('');
};


  const initialColumns = {
    program_date: true,
    id_program: true,
    departure: true,
    destination: true,
    type: true,
    observation: true,
    status: true,
    nom_conducteur: true,
    immatriculation_vehicule: true,
    client_name: true,
  };

  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setLimit(parseInt(newValue));
    setCurrentPage(1);
    await fetchPrograms();
    //setProgram(commentsFormServer);
    window.scrollTo(0, 0);
  };
  const handlePageClick = async (data: any) => { //**********Needs review
      const nextPage = data.selected + 1;
      await fetchPrograms(nextPage);
      //setProgram(commentsFormServer);
      window.scrollTo(0, 0);
    };
   const columnsMap = {
      ...(id_user === "1" && { id_program: "ID" }),
      program_date: "Program Date",
      client_name: "Client",
      departure: "Departure",
      destination: "Destination",
      type: "Type",
      nom_conducteur: "Driver",
      immatriculation_vehicule: "Vehicle",
      observation: "Observation",
      status: "Status",
    };
    const handleColumnChange = (column: string) => {
        setSelectedColumns((prevState: any) => ({
          ...prevState,
          [column]: !prevState[column],
        }));
      };


    const [searchTerm, setSearchTerm] = useState('');
    const [formData, setFormData] = useState<ProgramFormData>({
    program_date: "",
    id_client: "",
    id_departure: "",
    destination_ids: [],
    type: "",
    id_conducteur: "",
    id_vehicle: "",
    observation: "",
    status: ""
    });



  const handleAdvancedSearch = async (event: any) => {
    setSearch(event.target.value);
    setCurrentPage(1);

    //const commentsFromServer = await fetchPrograms();
    //setProgram(commentsFromServer);
  };

    const handleTypeSearch = (selectedValue: string) => {
    let newType = 0;
    switch (selectedValue) {
      case "ID Program":
        newType = 0;
        break;
      case "Program Date":
        newType = 1;
        break;
      case "Client":
        newType = 2;
        break;
      case "Departure":
        newType = 3;
        break;
      case "Destination":
        newType = 4;
        break;
      case "Type":
        newType = 5;
        break;
      case "Driver":
        newType = 6;
        break;
      case "Vehicle":
        newType = 7;
        break;
      case "Observation":
        newType = 8;
        break;
      case "Status":
        newType = 9;
        break;
      default:
        console.log("Unknown selection");
        break;
    }
    setSearch(""); 
    setCurrentPage(1);
    setType(newType);
    setTypeSearch(selectedValue);
    fetchPrograms();
  };
  useEffect(() => {
  console.log("Parent typeSearch updated to:", typeSearch);
  console.log("Parent type updated to:", type);
}, [typeSearch, type]);

const menuItems = useMemo(() => {
  return [
    ...(id_user === "1" ? ["ID Program"] : []), 
    "Program Date",
    "Client",
    "Departure",
    "Destination",
    "Type",
    "Driver",
    "Vehicle",
    "Observation",
    "Status",
  ];
}, [id_user]); 
const [drivers, setDrivers] = useState<Driver[]>([]);
const [destinations, setDestinations] = useState<Destination[]>([]);
const [vehicles, setVehicles] = useState<Vehicle[]>([]);
const [clients, setClients] = useState<Client[]>([]);
      type Driver = {
        id_conducteur: number;
        nom_conducteur: string;
        prenom_conducteur: string;
        };

        type Vehicle = {
        id_vehicule: number;
        immatriculation_vehicule: string;
        };

        type Client = {
        id_client: number;
        client_name: string;
        };
        type Destination = {
        id_destination: number;
        name: string;
        };

const optionsReady = drivers.length > 0 && vehicles.length > 0 && clients.length > 0;
const geopuserID = localStorage.getItem("GeopUserID") || localStorage.getItem("userid");

// useEffect to handle edit data
useEffect(() => {
    if (editProgramData && optionsReady) {
      console.log("editProgramData:", editProgramData);
      enterEditMode(editProgramData.id_program, editProgramData);
    } else {
      exitEditMode();
    }
  }, [editProgramData,optionsReady]);

        useEffect(() => {
        if (!show) return;
        if (!backendUrl) return;
        console.log("geopuserID in NewProgram:", geopuserID);

        const fetchDrivers = async () => {
        try {
            console.log("geopuserID in NewProgram:", geopuserID);
            const url = geopuserID ? `${backendUrl}/api/program/drivers/${geopuserID}` : `${backendUrl}/api/program/drivers`;
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch drivers");
            const data = await response.json();
            console.log("Drivers API data:", data);
            setDrivers(
        data
          .filter((driver: any) => driver.nom_conducteur?.trim() !== "" && driver.prenom_conducteur?.trim() !== "")
          .map((driver: any) => ({
            id_conducteur: driver.id_conducteur,
            nom_conducteur: driver.nom_conducteur,
            prenom_conducteur: driver.prenom_conducteur,
          }))
      );
      console.log("*******drivers:", data);
        } catch (error) {
            console.error("Error fetching drivers:", error);
            setDrivers([]);
        }
        };

        const fetchVehicles = async () => {
        try {
            const url = geopuserID ? `${backendUrl}/api/program/vehicles/${geopuserID}` : `${backendUrl}/api/program/vehicles`;
            const res = await fetch(url);
            if (!res.ok) throw new Error("Failed to fetch vehicles");
            const json = await res.json();
            console.log("Vehicles API data:", json);
            setVehicles(Array.isArray(json) ? json : []);
            console.log("*****vehicles:", json);

        } catch (err) {
            console.error("Error fetching vehicles:", err);
            setVehicles([]);
        }
        };

        const fetchClients = async () => {
        try {
            const url = geopuserID ? `${backendUrl}/api/program/clients/${geopuserID}` : `${backendUrl}/api/program/clients`;
            const res = await fetch(url);
            if (!res.ok) throw new Error("Failed to fetch clients");
            const json = await res.json();
            console.log("Clients API data:", json);
            setClients(Array.isArray(json) ? json : []);
            console.log("******clients:", json);
        } catch (err) {
            console.error("Error fetching clients:", err);
            setClients([]);
        }
        };
        const fetchDestinations = async () => {
        try {
            const res = await fetch(`${backendUrl}/api/destinations`, {
                credentials: "include"
            });
            if (res.ok) {
                const data = await res.json();
                setDestinations(data);
            }
        } catch (error) {
            console.error("Error fetching destinations:", error);
        }
        };


        fetchDrivers();
        fetchVehicles();
        fetchClients();
        fetchPrograms();
        fetchDestinations();
        }, [show, backendUrl, geopuserID,limit, currentPage, search, type, column, sort]);
    
   

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    /*const validateForm = () => {
    // Vérifier si tous les champs obligatoires sont remplis
    if (
        !formData.program_date ||
        !formData.id_client ||
        !formData.departure ||
        !formData.destination ||
        !formData.type ||
        !formData.id_conducteur ||
        !formData.id_vehicle ||
        !formData.status
    ) {
        toast.error("Please fill out all required fields.", {
            position: "bottom-right",
            autoClose: 2400,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Bounce,
        });
        return false;
    }

    // Vérifier que la date du programme n'est pas dans le passé
    const programDate = new Date(formData.program_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time

    if (programDate < today) {
        toast.error("Program date cannot be in the past.", {
            position: "bottom-right",
            autoClose: 2400,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Bounce,
        });
        return false;
    }

    return true;
};*/

const handleCreateProgram = async () => {
  // Basic validation
  if (!formData.program_date || !formData.id_departure || !formData.destination_ids || !formData.type) {
    toast.error("Please fill out required fields.");
    return;
  }

  try {
    const programData = {
      program_date: formData.program_date,
      id_client: formData.id_client || null,
      id_site,
      id_departure: formData.id_departure,
      type: formData.type,
      id_conducteur: formData.id_conducteur || null,
      id_vehicle: formData.id_vehicle || null,
      observation: formData.observation,
      status: formData.status || "planned",
    };

    const payload = {
      programData: programData,
      destination_ids: formData.destination_ids
    };

    const response = await fetch(`${backendUrl}/api/program/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const txt = await response.text();
      console.error("Error response create:", txt);
      throw new Error("Error adding program");
    }

    toast.success("Program added successfully!");
    //onHide?.();
    await fetchPrograms();
    onSuccess?.();
    exitEditMode();// Reset form but keep modal open
  } catch (error) {
    console.error("Error creating program:", error);
    toast.error("Error creating program");
  }
};



const handleUpdateProgram = async () => {
  // Basic validation (same as create)
  if (!formData.program_date || !formData.id_departure || formData.destination_ids.length === 0 || !formData.type) {
    toast.error("Please fill out required fields.");
    return;
  }

  try {
     const programData = {
      program_date: formData.program_date,
      id_client: formData.id_client || null,
      id_site,
      id_departure: formData.id_departure,       
      type: formData.type,
      id_conducteur: formData.id_conducteur || null,
      id_vehicle: formData.id_vehicle || null,
      observation: formData.observation,
      status: formData.status || "planned",
    };

    const payload = {
      ...programData,
      destination_ids: formData.destination_ids    
    };

    const response = await fetch(`${backendUrl}/api/program/update/${editingProgramId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const txt = await response.text();
      console.error("Error response update:", txt);
      throw new Error("Error updating program");
    }

    toast.success("Program updated successfully!");
    //onHide?.();
    await fetchPrograms();
    onSuccess?.();
    exitEditMode();
  } catch (error) {
    console.error("Error updating program:", error);
  }
};


    const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isEditMode && editingProgramId) {
      await handleUpdateProgram();
  } else {
      await handleCreateProgram();
  }
  
};


    /*const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            const response = await fetch(`${backendUrl}/api/geop/addnewDeadline/${geopuserID}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Error adding Deadline.");
            }

            const result = await response.json();

            toast.success("Deadline added successfully!", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
                transition: Bounce,
            });

            // Reset form data
            setFormData({
                id_conducteur: "",
                date_start_Deadline: "",
                date_end_Deadline: "",
                type_Deadline: "",
            });

            if (onSuccess) {
                onSuccess();
            }

            onHide();
        } catch (error) {
            console.error("Error adding Deadline:", error);
            toast.error("Error adding Deadline. Please try again.", {
                position: "bottom-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "light",
                transition: Bounce,
            });
        }
    };*/

const fetchPrograms = async (pageOverride?: number) => {
  
  try {
    setLoading(true);
    const pageToUse = pageOverride ?? currentPage;
    if (pageOverride) setCurrentPage(pageToUse);
    const res = await fetch(`${backendUrl}/api/program/search`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        limitValue: limit,
        currentPage: pageToUse,
        id_site,
        search,
        type,
        column,
        sort,
      }),
    });

    if (!res.ok) throw new Error("Failed to fetch programs");
    const data = await res.json();

    // Fetch total count and page count
    const totalRes = await fetch(`${backendUrl}/api/program/totalpage`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_user, search, type,id_site }),
    });
    if (!totalRes.ok) throw new Error("Failed to fetch total count");
    const totalData = await totalRes.json();
    const totalCount = totalData[0]?.count || 0;
    setListProgram(Array.isArray(data) ? data : []);
    setTotal(totalCount);
    setPageCount(Math.ceil(totalCount / limit));
  } catch (err) {
    console.error("Error fetching programs:", err);
    setListProgram([]);
    setTotal(0);
    setPageCount(0);
  } finally {
    setLoading(false);
  }
};
  const getStatusIcon = (status: string) => {
    switch (status) {
      case "planned":
        return <><i className="fas fa-calendar-alt" style={{ color: "#17a2b8", marginRight: "5px" }}></i> {translate("Planned")}</>;
      case "in_progress":
        return <><i className="fas fa-spinner" style={{ color: "#007bff", marginRight: "5px" }}></i> {translate("Progress")}</>;
      case "completed":
        return <><i className="fas fa-check-circle" style={{ color: "#28a745", marginRight: "5px" }}></i> {translate("completed")}</>;
      case "canceled":
        return <><i className="fas fa-times-circle" style={{ color: "#dc3545", marginRight: "5px" }}></i> {translate("Canceled")}</>;
      default:
        return <><i className="fas fa-question-circle" style={{ color: "#6c757d", marginRight: "5px" }}></i> {translate("Unknown")}</>;
    }
  };




    return (
      <Modal show={show} onHide={handleModalHide} size= "sm" centered className="modal-fullscreen-custom">
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? (
              <span style={{ color: '#28a745', fontWeight: '600' }}>Update Program</span>
            ) : (
              <span style={{ color: '#007bff', fontWeight: '600' }}>New Program</span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="row g-3">

        {/* Program Date */}
        <div className="col-12 col-md-6">
          <Form.Group controlId="program_date">
            <Form.Label>{translate("Program Date")}</Form.Label>
            <Form.Control
              type="date"
              value={formData.program_date}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

        {/* Client */}
        <div className="col-12 col-md-6">
          <SelectGroup
            controlId="id_client"
            name="id_client"
            label={translate("Client")}
            icon="user"
            options={clients.map(c => ({ value: String(c.id_client), label: c.client_name }))}
            valueType={{
              value: formData.id_client || "",
              label: clients.find(c => String(c.id_client) === formData.id_client)?.client_name
                || translate("Select Client"),
            }}
            onChange={(selected) => setFormData(prev => ({
              ...prev,
              id_client: String(selected.value),
            }))}
            
          />
        </div>

        {/* Departure */}
        <div className="col-12 col-md-6">
          <Form.Group controlId="id_departure">
        <Form.Label>{translate("Departure")}</Form.Label>
        <Form.Control
            as="select"
            value={formData.id_departure}
            onChange={(e: React.ChangeEvent<any>) => {  
                setFormData(prev => ({
                    ...prev,
                    id_departure: e.target.value
                }));
            }}
        >
            <option value="">{translate("Select departure")}</option>
            {destinations.map(dest => (
                <option key={dest.id_destination} value={dest.id_destination.toString()}>
                    {dest.name}
                </option>
            ))}
        </Form.Control>
    </Form.Group>
        </div>

        {/* Destination */}
        <div className="col-12 col-md-6">
    <Form.Group controlId="destination_ids">
        <Form.Label>{translate("Destination")}</Form.Label>
        <div className="border rounded p-2" style={{ minHeight: '38px' }}>
            {/* Selected Tags + Search Input */}
            <div className="d-flex flex-wrap align-items-center">
                {/* Display tags */}
                {formData.destination_ids.map((destId, index) => {
                    const destination = destinations.find(d => d.id_destination.toString() === destId);
                    return (
                        <span key={destId} className="badge bg-primary me-1 mb-1 p-2 d-inline-flex align-items-center">
                            {destination?.name || `ID: ${destId}`}
                            <button 
                                type="button"
                                className="btn-close btn-close-white ms-1"
                                style={{ fontSize: '0.7rem' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setFormData(prev => ({
                                        ...prev,
                                        destination_ids: prev.destination_ids.filter((_, i) => i !== index)
                                    }));
                                }}
                            ></button>
                        </span>
                    );
                })}
                
                {/* Search Input */}
                <input
                    type="text"
                    className="border-0 flex-grow-1 outline-none"
                    placeholder={formData.destination_ids.length === 0 ? translate("Search destinations...") : ""}
                    style={{ 
                        minWidth: '100px', 
                        outline: 'none',
                        border: 'none !important',
                        boxShadow: 'none !important'
                    }}
                    value={searchTerm}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const searchTerm = e.target.value.toLowerCase();
                        // We'll filter the dropdown based on this
                        setSearchTerm(searchTerm);
                    }}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Backspace' && e.currentTarget.value === '') {
                            // Remove last tag when backspace pressed on empty input
                            setFormData(prev => ({
                                ...prev,
                                destination_ids: prev.destination_ids.slice(0, -1)
                            }));
                        }
                    }}
                />
            </div>
        </div>

        {/* Dropdown Menu */}
        <div className="dropdown">
            <div 
                className="dropdown-menu w-100 show" 
                style={{ 
                    maxHeight: '200px', 
                    overflowY: 'auto',
                    display: searchTerm ? 'block' : 'none' 
                }}
            >
                {destinations
                    .filter(dest => 
                        !formData.destination_ids.includes(dest.id_destination.toString()) &&
                        dest.name.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map(dest => (
                        <button 
                            key={dest.id_destination}
                            type="button"
                            className="dropdown-item"
                            onClick={() => {
                                setFormData(prev => ({
                                    ...prev,
                                    destination_ids: [...prev.destination_ids, dest.id_destination.toString()]
                                }));
                                setSearchTerm(''); 
                            }}
                        >
                            {dest.name}
                        </button>
                    ))
                }
                {destinations.filter(dest => 
                    !formData.destination_ids.includes(dest.id_destination.toString()) &&
                    dest.name.toLowerCase().includes(searchTerm.toLowerCase())
                ).length === 0 && searchTerm && (
                    <div className="dropdown-item text-muted">
                        No destinations found
                    </div>
                )}
            </div>
        </div>
        
        <Form.Text className="text-muted">
            Type to search destinations, click × to remove
        </Form.Text>
    </Form.Group>
</div>
        {/* Type */}
        <div className="col-12 col-md-6">
          <Form.Group controlId="type">
            <Form.Label>{translate("Type")}</Form.Label>
            <Form.Control
              as="select"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="">{translate("Select type")}</option>
              {typeOptions.map(t => <option key={t} value={t}>{t}</option>)}
            </Form.Control>
          </Form.Group>
        </div>

        {/* Driver */}
        <div className="col-12 col-md-6">
          <SelectGroup
            controlId="id_conducteur"
            name="id_conducteur"
            label={translate("Driver")}
            icon="user-tie"
            options={drivers.map(d => ({
              value: String(d.id_conducteur),
              label: `${d.prenom_conducteur} ${d.nom_conducteur}`,
            }))}
            valueType={{
              value: formData.id_conducteur || "",
              label: drivers.find(d => String(d.id_conducteur) === formData.id_conducteur)
                ? `${drivers.find(d => String(d.id_conducteur) === formData.id_conducteur)?.prenom_conducteur} ${drivers.find(d => d.id_conducteur === Number(formData.id_conducteur))?.nom_conducteur}`
                : translate("Select Driver"),
            }}
            onChange={(selected) => setFormData(prev => ({
              ...prev,
              id_conducteur: String(selected.value),
            }))}
          />
        </div>

        {/* Vehicle */}
        <div className="col-12 col-md-6">
          <SelectGroup
            controlId="id_vehicle"
            name="id_vehicle"
            label={translate("Vehicle")}
            icon="truck"
            options={vehicles.map(v => ({
              value: String(v.id_vehicule),
              label: v.immatriculation_vehicule || `#${v.id_vehicule}`,
            }))}
            valueType={{
              value: formData.id_vehicle || "",
              label: vehicles.find(v => String(v.id_vehicule) === formData.id_vehicle)
                ? vehicles.find(v => String(v.id_vehicule) === formData.id_vehicle)?.immatriculation_vehicule || `#${formData.id_vehicle}`
                : translate("Select Vehicle"),
            }}
            onChange={(selected) => setFormData(prev => ({
              ...prev,
              id_vehicle: String(selected.value),
            }))}
          />
        </div>

           {/* Status */}
        <div className="col-12 col-md-6">
          <Form.Group controlId="status">
            <Form.Label>{translate("Status")}</Form.Label>
            <Form.Control
              as="select"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="">{translate("Select status")}</option>
              {statusOptions.map(s => <option key={s} value={s}>{s}</option>)}
            </Form.Control>
          </Form.Group>
        </div>

        {/* Observation */}
        <div className="col-12 col-md-12">
          <Form.Group controlId="observation">
            <Form.Label>{translate("Observation")}</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={formData.observation}
              onChange={handleChange}
            />
          </Form.Group>
        </div>

     

      </div>
      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={handleModalHide}>
          {translate("Close")}
        </Button>
        {isEditMode && (
    <Button 
      variant="outline-secondary" 
      onClick={exitEditMode}
    >
      <i className="ri-add-line"></i> {translate("Switch to Add")}
    </Button>
  )}
  <Button 
    variant={isEditMode ? "success" : "primary"} 
    type="submit"
  >
    {isEditMode ? (
      <><i className="ri-pencil-line"></i> {translate("Update Program")}</>
    ) : (
      <><i className="ri-add-line"></i> {translate("Add Program")}</>
    )}
  </Button>
        {/*<Button variant="primary" type="submit">
          {translate("Add")}
        </Button>*/}
      </div>
<h5>Created Programs({total})</h5>
  <ProgramTable
    loading={loading}
    programs={list_Program}
    selectedColumns={selectedColumns}
    selectedDeadlines={selectedDeadlines}
    selectAll={selectAll}
    handleSelectAllDrivers={handleSelectAllDrivers}
    handleDeadlinesSelect={(id: string) => {
      setSelectedDeadlines((prev) =>
        prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]
      );
    }}
    copiedId={copiedId}
    copyToClipboard={copyToClipboard}
    translate={(text: string) => text} // temporary
    sortColumn={column}
    sortOrder={sort}
    handleSortingColumn={(col) => {
    setColumn(col);
    setSort(sort === "ASC" ? "DESC" : "ASC");
    fetchPrograms(); 
  }}
    handleShowNewDeadlineModal={() => {}}
    handleshowShowProgramModal={handleshowShowProgramModal}
    handleDeleteProgramModal={handleDeleteProgramModal}
    /*handleEditProgramModal={(program) => {
    enterEditMode(program.id_program, program);
    handleShowNewDeadlineModal(); 
  }}*/
    //handleEditProgramModal={handleEditProgram}
    handleEditProgramModal={(program) => enterEditMode(program.id_program, program)}
    getStatusIcon={getStatusIcon}
    limit={limit}
    total={total}
    pageCount={pageCount}
    currentPage={currentPage}
    handleSelectChange={handleSelectChange}
    handlePageClick={handlePageClick}
    columnsMap={columnsMap}
    handleColumnChange={handleColumnChange}
    initialColumns={initialColumns}
    menuItems={menuItems}
    handleTypeSearch={handleTypeSearch}
    //typeSearch={typeSearch}
    type={type}
    search={search}
    handleAdvancedSearch={handleAdvancedSearch}
    />
    <ModalDeleteProgram
    show={showDeleteProgramModal}
    onHide={() => { setShowDeleteProgramModal(false); setSelectedProgramId(null); }}
    id_program={selectedProgramId}
    onSuccess={() => {
      // Refresh after delete
      fetchPrograms();
    }}
/>
<ModalShowProgram
  show={showShowProgramModal}
  onHide={handleCloseShowProgramModal}
  id_program={selectedProgramId}
/>
    </Modal.Body>

    <Modal.Footer>
    </Modal.Footer>
  </Form>
</Modal>
    );


};

export default ModalNewDeadline;